import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { CartItem, CartItemGroup, CartItemType } from '../cart.model';
import { CartService } from '../cart.service';
import { DeleteCartItemMode } from '../../../../pages/project/project.page';
import { MatExpansionPanel } from "@angular/material/expansion";

@Component({
	selector: 'app-cart-list-subgroup-row',
	templateUrl: './cart-list-subgroup-row.component.html',
	styleUrls: ['./cart-list-subgroup-row.component.scss']
})
export class CartListSubgroupRowComponent implements OnInit {
	readonly DeleteCartItemMode = DeleteCartItemMode;
	readonly CartItemType = CartItemType;


	@ViewChild('expansionPanel') expansionPanel: MatExpansionPanel;

	@Input() group: CartItemGroup;
	@Input() mode: 'list' | 'checkout' | 'post-checkout'; // Determines the template being used.
	@Input() showGroupActions = true;
	@Input() showSizeCount: boolean = true;
	@Input() showExport: boolean = false;
	@Input() showDelete: boolean = false;
	@Input() showReview: boolean = false;
	@Input() useItemTranslations: boolean = false; // Use when we are not handling a real item, but a preview.
	@Input() highlightQuery: string; // Highlight a regex match in the group/item names
	@Input() actionInProgress: {group?: any, itemIds?: string[]} | null;
	@Input() isGuestUser = false;

	@Input() forcePanelsOpen: boolean = false; // force panels open on init
	@Input() expanded: boolean = false;
	@Output() panelExpansionChange: EventEmitter<boolean> = new EventEmitter<boolean>();

	@Output() goToGroup: EventEmitter<CartItemGroup> = new EventEmitter<CartItemGroup>();
	@Output() goToItem: EventEmitter<{ item: CartItem, group: CartItemGroup }> = new EventEmitter<{ item: CartItem, group: CartItemGroup }>();
	@Output() deleteItems: EventEmitter<{ items: CartItem[]; mode: DeleteCartItemMode }> = new EventEmitter<{
		items: CartItem[];
		mode: DeleteCartItemMode;
	}>();
	@Output() deleteItem: EventEmitter<CartItem> = new EventEmitter<CartItem>();
	@Output() exportItem = new EventEmitter<CartItem>();
	@Output() groupAction = new EventEmitter<{ action: string; group: CartItemGroup | any }>();
	@Output() itemAction = new EventEmitter<{ action: string; item: CartItem | any }>();

	constructor(
		public cartService: CartService,
	) { }

	ngOnInit() {
		if (this.forcePanelsOpen && !this.expanded) {
			this.expanded = true;
		}
	}

}
